import { render, staticRenderFns } from "./Procedure.vue?vue&type=template&id=68f5f351"
import script from "./Procedure.vue?vue&type=script&lang=js"
export * from "./Procedure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports